import { render, staticRenderFns } from "./OrganizationIndividualSchool.vue?vue&type=template&id=7add678f&scoped=true&"
import script from "./OrganizationIndividualSchool.vue?vue&type=script&lang=js&"
export * from "./OrganizationIndividualSchool.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationIndividualSchool.vue?vue&type=style&index=0&id=7add678f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add678f",
  null
  
)

export default component.exports